import { themeSettings } from "../../settings";
/**
 * Generate Lightbox
 *
 * @param {string} classes
 * @return {void}
 */
const generateLightbox = ( classes ) => {

	const lightbox = document.querySelector( '.c-lightbox' );

	if ( lightbox === null ) {

		const lightboxEl = document.createElement( 'div' );
		lightboxEl.className = `c-lightbox ${ classes }`

		const lightboxContent = document.createElement( 'div' );
		lightboxContent.className = 'c-lightbox__content';

		const closeButton = document.createElement( 'button' );
		closeButton.className = 'c-lightbox__close js-lightbox-close';

		// Create the img element
		const closeImage = document.createElement( 'img' );
		closeImage.src = `${themeSettings.templateUrl}/img/icon-close-lightbox.svg`;
		closeImage.width = '50';
		closeImage.height = '50';
		closeImage.loading = 'lazy';

		// Append the img to the button
		closeButton.appendChild( closeImage );
		lightboxEl.appendChild( closeButton );

		const overlay = document.createElement( 'div' );
		overlay.className = 'c-lightbox__overlay js-lightbox-close';

		lightboxEl.appendChild( lightboxContent );
		lightboxEl.appendChild( overlay );
		document.body.appendChild( lightboxEl );

	}

}

/**
 * Close Lightbox
 * @return {void}
 */
const closeLightbox = () => {

	const lightbox = document.querySelector( '.c-lightbox' );
	const lightboxContent = lightbox.querySelector( '.c-lightbox__content' );
	const closeButtons = lightbox.querySelectorAll( '.js-lightbox-close' );

	closeButtons.forEach( ( closeButton ) => {

		closeButton.addEventListener( 'click', () => {

			lightbox.classList.remove( 'c-lightbox--open' );
			lightboxContent.innerHTML = '';


		} );

	} );

}

/**
 * Lightbox
 *
 * @param {string} classes
 * @since 1.0.0
 * @return {void}
 */
const lightbox = ( classes ) => {

	generateLightbox( classes );
	closeLightbox();

}

export { generateLightbox, lightbox };
